module.exports = __webpack_public_path__ + "img/hatford_slide_2.1c42eb1a.jpg";